import { AlfrescoApiService } from '@alfresco/adf-core';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReviewerService {
  apiURL: any;
  headers: any;

  constructor(private apiService: AlfrescoApiService) {}

  private publicApiCall(path: string, httpMethod: string, params?: any[]): Promise<any> {
    return this.apiService.getInstance().contentClient.callApi(path, httpMethod, ...params);
  }

  getRenditionsInfo(nodeId: string, renId: string): Observable<any> {
    const pathService = `/nodes/${nodeId}/renditions/${renId}`;
    const httpMethod = 'GET';
    return from(this.publicApiCall(pathService, httpMethod, [{}, {}, {}, {}, {}, ['application/json'], ['application/json']]));
  }
  getRenditionContent(nodeId: string, renId: string): Promise<any> {
    const pathService = `/nodes/${nodeId}/renditions/${renId}/content?attachment=true&placeholder=false`;
    const httpMethod = 'GET';
    return this.publicApiCall(pathService, httpMethod, [null, null, null, null, null, ['application/json'], ['blob'], null, null, 'blob']).then(
      (response: any) => {
        if (response instanceof Blob) {
          return this.blobToBase64(response);
        } else {
          return Promise.reject(new Error('Response is not of type Blob'));
        }
      }
    );
  }

  createRendition(nodeId: string, renId: string): Observable<any> {
    const pathService = `/nodes/${nodeId}/renditions`;
    const httpMethod = 'POST';
    const body = { id: renId };
    return from(this.publicApiCall(pathService, httpMethod, [null, null, null, null, body, ['application/json'], ['application/json']]));
  }

  async getCheckRenditions(nodeId: string, renId: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const attemptGetRenditionsInfo = () => {
        this.getRenditionsInfo(nodeId, renId).subscribe({
          next: (data) => {
            const status = data.entry.status;
            console.log('getCheckRenditions status: ', status);
            if (status === 'CREATED') {
              resolve(true);
            } else {
              resolve(false); // Resolve false after max retries
            }
          },
          error: (error) => {
            console.log('error getMimeType: ', error);
            reject(false);
          }
        });
      };
      attemptGetRenditionsInfo(); // Initial attempt
    });
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        const base64Content = base64String.split(';base64,')[1];
        resolve(base64Content);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(blob);
    });
  }

  async createRenditionData(nodeId: string, renId: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const attemptCreateRendition = () => {
        this.createRendition(nodeId, renId).subscribe({
          next: (data) => {
            if (data.status === 202) {
              console.log('createRenditionData success:', data);
              resolve(true);
            } else {
              console.log('createRenditionData acepted');
              resolve(true);
            }
          },
          error: (error) => {
            if ([400, 401, 403, 404, 501].includes(error.status)) {
              console.error('Error occurred with status', error.status, ':', error.error);
              reject(error);
            } else if (error.status === 409) {
              console.error('All renditions requested already exist:', error.error);
              resolve(true);
            } else {
              console.error('Error occurred:', error);
              setTimeout(() => {
                attemptCreateRendition(); // Retry after 3 seconds
              }, 3000);
            }
          }
        });
      };
      attemptCreateRendition(); // Initial attempt
    });
  }

  async getRetryCheckRenditions(nodeId: string, renId: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const attemptGetRenditionsInfo = () => {
        this.getRenditionsInfo(nodeId, renId).subscribe({
          next: (data) => {
            const status = data.entry.status;
            console.log('getRetryCheckRenditions status: ', status);
            if (status === 'CREATED') {
              resolve(true);
            } else {
              resolve(false); // Resolve false after max retries
            }
          },
          error: (error) => {
            console.log('error getMimeType: ', error);
            reject(false);
          }
        });
      };
      attemptGetRenditionsInfo(); // Initial attempt
    });
  }

  downloadNodeVersion(nodeId: string, versionId: string): Promise<any> {
    const pathService = `/nodes/${nodeId}/versions/${versionId}/content?attachment=true`;
    const httpMethod = 'GET';
    return this.publicApiCall(pathService, httpMethod, [null, null, null, null, null, ['application/json'], ['blob'], null, null, 'blob']).then(
      (response: any) => {
        if (response instanceof Blob) {
          return this.blobToBase64Edit(response);
        } else {
          return Promise.reject(new Error('Response is not of type Blob'));
        }
      }
    );
  }

  downloadNode(nodeId: string): Promise<any> {
    const pathService = `/nodes/${nodeId}/content?attachment=true`;
    const httpMethod = 'GET';
    return this.publicApiCall(pathService, httpMethod, [null, null, null, null, null, ['application/json'], ['blob'], null, null, 'blob']).then(
      (response: any) => {
        if (response instanceof Blob) {
          return this.blobToBase64Edit(response);
        } else {
          return Promise.reject(new Error('Response is not of type Blob'));
        }
      }
    );
  }

  private async blobToBase64Edit(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;
        resolve(base64String);
      };

      reader.onerror = () => {
        reader.abort();
        reject(new DOMException('Failed to read the blob.'));
      };

      reader.readAsDataURL(blob);
    });
  }
}
